<template>
    <image-widget :src="club?.cover_image" :title="title ?? club.display_name" :color="club?.color ?? $config.public.colors.secondary" :to="to" :blur="1">
        <div class="absolute flex items-center justify-center w-full">
            <avatar :model="club" :size="$breakpoint.smAndUp ? 40 : 32" :color="club?.avatar_thumbnail ? 'transparent' : 'white'" class="shadow"/>
        </div>
    </image-widget>
</template>

<script>

export default {
    name: "ClubWidget",

    props: {
		to: {
			type: [String, Object],
			default: null
		},

        club: {
            type: Object,
            default: null
        },

        title: {
            type: String,
            default: null
        },
    }
}
</script>